import { useTranslation } from 'react-i18next';

export enum RestrictDuplicateUrlOfCardsInTimeFrame {
  HALF_DAY = 'HALF_DAY',
  NEVER = 'NEVER',
  ONE_DAY = 'ONE_DAY',
  ONE_HOUR = 'ONE_HOUR',
  ONE_WEEK = 'ONE_WEEK',
  SIX_HOURS = 'SIX_HOURS',
  THREE_DAYS = 'THREE_DAYS',
  THREE_HOURS = 'THREE_HOURS',
  TWO_DAYS = 'TWO_DAYS',
}

export const useRestrictDuplicateUrlOfCardsInTimeFrame = () => {
  const { t } = useTranslation();

  return {
    options: [
      { id: RestrictDuplicateUrlOfCardsInTimeFrame.NEVER, title: t('common.never') },
      {
        id: RestrictDuplicateUrlOfCardsInTimeFrame.ONE_HOUR,
        title: t('common.hours', { count: 1 }),
      },
      {
        id: RestrictDuplicateUrlOfCardsInTimeFrame.THREE_HOURS,
        title: t('common.hours', { count: 3 }),
      },
      {
        id: RestrictDuplicateUrlOfCardsInTimeFrame.SIX_HOURS,
        title: t('common.hours', { count: 6 }),
      },
      {
        id: RestrictDuplicateUrlOfCardsInTimeFrame.HALF_DAY,
        title: t('common.hours', { count: 12 }),
      },
      {
        id: RestrictDuplicateUrlOfCardsInTimeFrame.ONE_DAY,
        title: t('common.days', { count: 1 }),
      },
      {
        id: RestrictDuplicateUrlOfCardsInTimeFrame.TWO_DAYS,
        title: t('common.days', { count: 2 }),
      },
      {
        id: RestrictDuplicateUrlOfCardsInTimeFrame.THREE_DAYS,
        title: t('common.days', { count: 3 }),
      },
      {
        id: RestrictDuplicateUrlOfCardsInTimeFrame.ONE_WEEK,
        title: t('common.days', { count: 7 }),
      },
    ],
  };
};
